import { FC, useEffect, useState } from 'react';

import { Modal, Input, CustomSelect, Switch, Button } from '../../shared/ui';
import { timezoneList } from '../../assets/timezone';
import { IClient } from '../../store/types';

interface ICreateClientProps {
  open: boolean;
  close: () => void;
  save: (form: IFormDataClient) => void;
  clientData?: IClient;
}

export interface IFormDataClient {
  name: string;
  tz: string;
  active: boolean;
}
const defaultClient = {
  name: '',
  tz: '(GMT +03:00) Москва',
  active: true,
};

export const CreateClientForm: FC<ICreateClientProps> = ({ open, close, save, clientData }) => {
  const [formDataClient, setFormDataClient] = useState<IFormDataClient>(defaultClient);
  const [errorClient, setErrorClient] = useState('');
  const [errorTZ, setErrorTZ] = useState('');

  useEffect(() => {
    if (clientData) {
      setFormDataClient((state) => ({
        ...state,
        name: clientData.full_name,

        tz: clientData.time_zone,

        active: clientData.is_active,
      }));
    } else {
      setFormDataClient(defaultClient);
    }
  }, [clientData, open]);

  const onBlurClient = (e: React.FocusEvent<HTMLInputElement>) => {
    if (e.target.value === '') {
      setErrorClient('Заполните поле Клиент');
    } else {
      setErrorClient('');
    }
  };
  const handleSave = () => {
    const tzListName = timezoneList.map((i) => i.name).includes(formDataClient.tz);

    if (formDataClient.name === '' || !tzListName) {
      setErrorClient(formDataClient.name === '' ? 'Заполните поле Клиент' : '');
      setErrorTZ(!tzListName ? 'Выберите из списка' : '');

      return;
    }
    save(formDataClient);
    handleClose();
  };

  const handleClose = () => {
    setErrorClient('');

    setErrorTZ('');

    setFormDataClient(defaultClient);
    close();
  };

  return (
    <Modal
      isOpen={open}
      onClose={handleClose}
      size="xl"
      fullscreenOnMobile
      title={clientData ? 'Редактирование клиента' : 'Создание клиента'}
      footer={
        <Button size="lg" variant="dark" onClick={handleSave}>
          Сохранить
        </Button>
      }
    >
      <div className="flex flex-col gap-3.5 lg:gap-5">
        <Input
          size="lg"
          label="Клиент (обязательное поле)"
          value={formDataClient.name}
          onChange={(e) => {
            if (e.target.value.length > 50) {
              return;
            }
            setFormDataClient({ ...formDataClient, name: e.target.value });
          }}
          placeholder="Введите ФИО или псевдоним"
          error={errorClient}
          onBlur={onBlurClient}
          showError={false}
        />

        <div className="w-full flex flex-col lg:flex-row lg:items-start gap-3.5 lg:gap-[30px]">
          <div className="w-full lg:max-w-[320px]">
            <CustomSelect
              size="lg"
              label="Часовой пояс клиента"
              items={timezoneList.map((el) => el.name)}
              selected={formDataClient.tz}
              onChange={(a) => {
                setFormDataClient({ ...formDataClient, tz: a });
                setErrorTZ('');
              }}
              helper="Выберите часовой пояс клиента, чтобы время встречи отображалось правильно для него и вас."
              error={errorTZ}
              showError={false}
            />
          </div>
          <div className="lg:pt-7">
            <Switch
              checked={formDataClient.active}
              onChange={(a) => {
                setFormDataClient({ ...formDataClient, active: a });
              }}
              label="Клиент Активный"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};
